import { useQuery } from 'query';
import { loadSA } from 'scenes/FinancePage/SA/sources';

import { details } from './queryKeyFactory';

export const useLoadSA = ({ id }: { id: number }) => {
  return useQuery(details({ id }), async () => {
    return loadSA({ id });
  });
};
